import { TableRow, TableCell, Typography, Button, Link as MuiLink } from '@mui/material'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import type { TransformedAssignedApplicantData } from '@/lib/apollo/query/getAssignedApplicants'
import { rowHeight } from '@/utils/table'

export type Props = {
  applicant: TransformedAssignedApplicantData
}

const Row: FC<Props> = ({ applicant }) => (
  <TableRow hover key={applicant.id} sx={{ height: rowHeight }}>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {applicant.fullName}
      </Typography>
    </TableCell>
    <TableCell component="td">
      <Typography variant="body2" noWrap>
        {applicant.processedBy.map((processedBy, i) => (
          <>
            {i > 0 && <>, </>}
            <MuiLink component={Link} to={`/executive/${processedBy.userId}`}>
              {processedBy.fullName}
            </MuiLink>
          </>
        ))}
      </Typography>
    </TableCell>
    <TableCell align="right" padding="none">
      <Button
        size="small"
        variant="text"
        component={Link}
        to={`/applicant/${applicant.id}`}
        sx={{ whitespace: 'noWrap' }}
      >
        View applicant
      </Button>
    </TableCell>
  </TableRow>
)

export default Row
